module.exports = __webpack_public_path__ + "static/media/eposter.d8336d47.png";